import PropTypes from 'prop-types';

const Panel = () => null;

Panel.propTypes = {
  className: PropTypes.string,
};

export default Panel;



// WEBPACK FOOTER //
// ./components/TableWithExpandablePanel/Panel.jsx